import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import freelancerAuthReducer from "./freelancerAuthSlice";
import employeeAuthReducer from "./employeeAuthSlice";

import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { setTokenGetter } from "../api/api";
import { setEmployeeTokenGetter } from "../api/employeeApi";

const rootReducer = combineReducers({
  auth: authReducer,
  freelancerAuth: freelancerAuthReducer,
  employeeAuth: employeeAuthReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "freelancerAuth", "employeeAuth"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/PAUSE",
          "persist/FLUSH",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
    }),
});

export const persistor = persistStore(store);

setTokenGetter(() => store.getState().auth.accessToken);
// Instância própria do portal do colaborador: um token nunca vai no lugar do
// outro, porque cada axios tem seu getter e lê um pedaço diferente do estado.
setEmployeeTokenGetter(() => store.getState().employeeAuth.accessToken);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
